app.factory('meedyALABService', ['$q', 'baseService', 'objectHelper', 'config',
    function($q, baseService, objectHelper, config) {

        function MeedyALABService() {

            this.getDataPage = function (criteria) {
                return  baseService.post(config.API_URL + '/meedy/alab/offers', criteria).then(
                    function (successResponse) {
                        var dataPage = objectHelper.translateObject(successResponse, MeedyLaboratoryTestsWrapper);
                        return dataPage;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getResources = function (offers) {
                return  baseService.post(config.API_URL + '/meedy/alab/resources', offers).then(
                    function (successResponse) {
                        var dataPage = objectHelper.translateObject(successResponse, MeedyOfficesWrapper);
                        return dataPage;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };
        }

        return new MeedyALABService();
    }
]);
